export default __webpack_public_path__ + "static/media/logo.8b969d35.svg";